import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { Store } from '../../store'

/**
 * Footer of modal used to edit org chart nodes
 */
@ngCore.Component({
  imports: [ds.button.Component],
  selector: 'atn-summit-org-chart-node-panel-footer',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
}
